import { parseHtml } from '@healthhub/react-ui';
import DOMPurify from 'dompurify';
import { useTranslation } from 'react-i18next';

import useToggle from '@shared/hooks/useToggle/useToggle';
import { escapeUnicodeToHtml } from '@shared/utils/string';

interface IShowMoreLessTextProps {
  activateTrans?: boolean;
  message: string;
  showLessByCount?: number;
  showLessWhen: string;
}

const ShowMoreLessText = ({ activateTrans, message, showLessByCount, showLessWhen }: IShowMoreLessTextProps) => {
  const { t } = useTranslation();
  const [isShowMore, showMoreToggle] = useToggle(true);

  const lessTextIndex = showLessWhen ? message.indexOf(showLessWhen) : showLessByCount || 0;
  const lessText = lessTextIndex >= 0 ? `${message.substring(0, lessTextIndex)}...` : message;
  const shouldSplit = message.trim().length > lessText.trim().length + 1;

  return (
    <>
      {/* if the text length is equal to the index just return the text */}
      {!shouldSplit && (
        <p className="whitespace-pre-wrap text-sm">{parseHtml(DOMPurify.sanitize(escapeUnicodeToHtml(message)))}</p>
      )}

      {!!shouldSplit && !!isShowMore && (
        <p className="word-break break-words text-sm">
          {parseHtml(DOMPurify.sanitize(escapeUnicodeToHtml(lessText)))}
          <button
            className="showmore inline-block cursor-pointer font-semibold text-theme-600"
            onClick={() => showMoreToggle()}
          >
            {activateTrans ? t('readMore') : 'Read more'}
          </button>
        </p>
      )}

      {!!shouldSplit && !isShowMore && (
        <p className="word-break break-words text-sm">
          {parseHtml(DOMPurify.sanitize(escapeUnicodeToHtml(message)))}
          <div className="pt-1.5">
            <button className="showless cursor-pointer font-semibold text-theme-600" onClick={() => showMoreToggle()}>
              {activateTrans ? t('readLess') : 'Read less'}
            </button>
          </div>
        </p>
      )}
    </>
  );
};

export default ShowMoreLessText;
